// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1zEVY","cell":"ColumnAccessor_cell__2CD4r","firstCellAccent":"ColumnAccessor_firstCellAccent__1S6Vx"};